import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../config/interceptor";
// https://dev.jaaga.ai/api/property/static/states/telangana/non-agriculture/property-binder/service.json

export const useStaticPropertyData = (
  state = "telangana",
  category,
  documentName,
  activeTab,
) => {
  return useQuery({
    enabled: Boolean(state && category),
    queryKey: [
      "static-property-data",
      state,
      category,
      documentName,
      activeTab,
    ],
    queryFn: async () => {
      const filePath =
        documentName && activeTab
          ? activeTab === "dont-know"
            ? `/api/property/static/states/${state}/${category}/dont-know/index.json`
            : `/api/property/static/states/${state}/${category}/${documentName}/${activeTab}/index.json`
          : documentName
            ? `/api/property/static/states/${state}/${category}/${documentName}/index.json`
            : `/api/property/static/states/${state}/${category}/index.json`;

      const res = await axiosInstance.get(filePath);
      return res.data;
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
